import type { Phase } from './types'

const startOfDay = (iso: string) => {
  const d = new Date(iso)
  d.setHours(0, 0, 0, 0)
  return d
}

/**
 * Inventario D5 (confirmado): `before` hasta las 00:00 del día de entrada; `arrival` hasta la hora de
 * entrada + 6 h; `during` hasta las 00:00 del día de salida; `checkout` hasta la hora de salida; `after`
 * después. `cancelled` si la reserva está cancelada. Hora local del dispositivo (riesgo R13).
 */
export function derivePhase(checkIn: string, checkOut: string, options: { cancelled?: boolean; leftAt?: string | null; now?: Date } = {}): Phase {
  if (options.cancelled) return 'cancelled'
  const now = options.now ?? new Date()
  if (options.leftAt && new Date(options.leftAt) <= now) return 'after'
  const arrivalDay = startOfDay(checkIn)
  const arrivalEnd = new Date(new Date(checkIn).getTime() + 6 * 60 * 60 * 1000)
  const checkoutDay = startOfDay(checkOut)
  const checkoutTime = new Date(checkOut)
  if (now < arrivalDay) return 'before'
  if (now < arrivalEnd) return 'arrival'
  if (now < checkoutDay) return 'during'
  if (now < checkoutTime) return 'checkout'
  return 'after'
}
